import {
  Home,
  Activity,
  Users,
  ShieldCheck,
  UserCheck,
  Database,
  Search,
  Gauge,
  ScrollText,
  HeartPulse,
  PlugZap,
  Info,
  TrendingUp,
  LucideIcon,
} from 'lucide-react';

/** A single navigable link in the sidebar. */
export interface NavLinkItem {
  label: string;
  to: string;
  icon: LucideIcon;
}

/** A labelled group of related links. */
export interface NavSection {
  label: string;
  items: NavLinkItem[];
}

/**
 * Data-driven, grouped navigation for the Ops Tool sidebar.
 * Rendered by mapping over these sections — no per-link JSX duplication.
 */
export const NAV_SECTIONS: NavSection[] = [
  {
    label: 'Overview',
    items: [
      { label: 'Home', to: '/', icon: Home },
      { label: 'ADME Status', to: '/status', icon: Activity },
    ],
  },
  {
    label: 'Access Management',
    items: [
      { label: 'Groups', to: '/groups', icon: Users },
      { label: 'Permission Guide', to: '/service-groups', icon: ShieldCheck },
      { label: 'Check Membership', to: '/operations/check-membership', icon: UserCheck },
    ],
  },
  {
    label: 'Data',
    items: [
      { label: 'Data Explorer', to: '/data-explorer', icon: Database },
      { label: 'Search', to: '/search', icon: Search },
    ],
  },
  {
    label: 'Monitoring',
    items: [
      { label: 'Data Monitoring', to: '/monitoring', icon: Gauge },
      { label: 'Active Users', to: '/active-users', icon: TrendingUp },
      { label: 'Logs', to: '/logs', icon: ScrollText },
      { label: 'Health', to: '/health', icon: HeartPulse },
      { label: 'API Health', to: '/api-health', icon: PlugZap },
    ],
  },
  {
    label: 'System',
    items: [
      { label: 'Info', to: '/info', icon: Info },
    ],
  },
];
